var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _radialGradient, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _radialGradient2, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _radialGradient3, _radialGradient4, _radialGradient5, _linearGradient27, _linearGradient28, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDollar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "511.999pt",
    viewBox: "1 1 511.999 511.999",
    width: "511.999pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 145.8083261814,
    x2: 379.0576562096,
    y1: 145.8083261814,
    y2: 379.0576562096
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af9ce6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff70ac"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 421.088557407,
    x2: 183.936580996,
    y1: 418.190234593,
    y2: 181.0381577898
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b53759",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b53759"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 140.084766075,
    x2: 140.084766075,
    xlinkHref: "#lg1",
    y1: 174.5331447986,
    y2: 67.5039160644
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af9ce6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0796ff"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 70.4807455788,
    x2: 96.4485935996,
    xlinkHref: "#lg2",
    y1: 75.19877741,
    y2: 101.1666254308
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientTransform: "matrix(-1.003922 0 0 1.003922 688.690196 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 429.8612,
    x2: 429.8612,
    xlinkHref: "#lg1",
    y1: 173.8513,
    y2: 30.3095
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2344,
    stopColor: "#fec33a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4454,
    stopColor: "#fbb840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6474,
    stopColor: "#f6a649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8426,
    stopColor: "#f08d56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97264"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial0",
    cx: 242.6651144662,
    cy: -12.6487144546,
    gradientUnits: "userSpaceOnUse",
    r: 65.1171919016,
    xlinkHref: "#lg3"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientTransform: "matrix(-1.003922 0 0 1.003922 688.690196 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 312.7503,
    x2: 312.7503,
    xlinkHref: "#lg1",
    y1: 173.8513,
    y2: 19.8574
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00e7b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4139,
    stopColor: "#1fa999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f4a72"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 412.8384268032,
    x2: 457.576102497,
    xlinkHref: "#lg4",
    y1: 10.1418208284,
    y2: 54.87939613
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientTransform: "matrix(-1.003922 0 0 -1.003922 -1626.08379 -2868.744634)",
    gradientUnits: "userSpaceOnUse",
    x1: -1990.1945,
    x2: -1990.1945,
    xlinkHref: "#lg1",
    y1: -3193.6873,
    y2: -3300.2986
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear8",
    gradientUnits: "userSpaceOnUse",
    x1: 424.7305050884,
    x2: 450.6983531092,
    xlinkHref: "#lg2",
    y1: 420.012299026,
    y2: 445.9801470468
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear9",
    gradientTransform: "matrix(1.003922 0 0 -1.003922 -2314.773986 -2868.744634)",
    gradientUnits: "userSpaceOnUse",
    x1: 2559.593,
    x2: 2559.593,
    xlinkHref: "#lg1",
    y1: -3193.6873,
    y2: -3337.229
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial1",
    cx: 240.3785820594,
    cy: 438.4945796372,
    gradientUnits: "userSpaceOnUse",
    r: 65.1171919016,
    xlinkHref: "#lg3"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear10",
    gradientTransform: "matrix(1.003922 0 0 -1.003922 -2314.773986 -2868.744634)",
    gradientUnits: "userSpaceOnUse",
    x1: 2442.4822,
    x2: 2442.4822,
    xlinkHref: "#lg1",
    y1: -3193.6873,
    y2: -3347.6812
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear11",
    gradientUnits: "userSpaceOnUse",
    x1: 58.5886672936,
    x2: 103.3262425952,
    xlinkHref: "#lg4",
    y1: 461.2851149202,
    y2: 506.0226902218
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear12",
    gradientTransform: "matrix(0 -1.003922 -1.003922 0 494.764976 673.246971)",
    gradientUnits: "userSpaceOnUse",
    x1: 414.4783,
    x2: 414.4783,
    xlinkHref: "#lg1",
    y1: 156.6836,
    y2: 13.1418
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb5b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff70ac"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear13",
    gradientUnits: "userSpaceOnUse",
    x1: 451.143472282,
    x2: 512.00022,
    xlinkHref: "#lg5",
    y1: 257.1433763736,
    y2: 257.1433763736
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear14",
    gradientTransform: "matrix(0 1.003922 1.003922 0 3363.509509 -2330.217111)",
    gradientUnits: "userSpaceOnUse",
    x1: 2574.9761,
    x2: 2574.9761,
    xlinkHref: "#lg1",
    y1: -3176.5195,
    y2: -3320.0613
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear15",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 60.856747718,
    xlinkHref: "#lg5",
    y1: 254.8568436264,
    y2: 254.8568436264
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear16",
    gradientUnits: "userSpaceOnUse",
    x1: 138.1911683986,
    x2: 377.1139628254,
    xlinkHref: "#lg3",
    y1: 254.754242798,
    y2: 254.754242798
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear17",
    gradientUnits: "userSpaceOnUse",
    x1: 246.2809403336,
    x2: 344.4709370344,
    y1: 232.8856090876,
    y2: 421.7127961066
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fca17a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#f69373",
    stopOpacity: 0.152941
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#ef816b",
    stopOpacity: 0.415686
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6926,
    stopColor: "#ea7666",
    stopOpacity: 0.694118
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97264"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e97264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b53759"
  }))), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear18",
    gradientUnits: "userSpaceOnUse",
    x1: 253.9771067778,
    x2: 242.3796994416,
    xlinkHref: "#lg6",
    y1: 292.033882346,
    y2: 409.6648285768
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear19",
    gradientUnits: "userSpaceOnUse",
    x1: 233.9915295628,
    x2: 198.1406718052,
    xlinkHref: "#lg6",
    y1: 298.0290033534,
    y2: 363.5983617238
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial2",
    cx: 223.4208,
    cy: 749.4034,
    gradientTransform: "matrix(1.003922 0 0 .897807 0 -508.028687)",
    gradientUnits: "userSpaceOnUse",
    r: 224.358,
    xlinkHref: "#lg3"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial3",
    cx: -1882.8333,
    cy: -9931.8945,
    gradientTransform: "matrix(-1.003922 0 0 -.897807 -1624.345098 -8647.647071)",
    gradientUnits: "userSpaceOnUse",
    r: 165.4675,
    xlinkHref: "#lg3"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial4",
    cx: 240.3647,
    cy: 776.9726,
    gradientTransform: "matrix(1.003922 0 0 .897807 0 -508.028687)",
    gradientUnits: "userSpaceOnUse",
    r: 186.2864,
    xlinkHref: "#lg3"
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear20",
    gradientUnits: "userSpaceOnUse",
    x1: 324.1756498824,
    x2: 183.7452334628,
    xlinkHref: "#lg6",
    y1: 291.290980066,
    y2: 199.1036337876
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear21",
    gradientUnits: "userSpaceOnUse",
    x1: 284.9169788958,
    x2: 177.8652623088,
    y1: 238.9713842516,
    y2: 238.9713842516
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97264"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m434.214844 256c0 98.425781-79.789063 178.214844-178.214844 178.214844s-178.214844-79.789063-178.214844-178.214844 79.789063-178.214844 178.214844-178.214844 178.214844 79.789063 178.214844 178.214844zm0 0",
    fill: "url(#linear0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m434.183594 258.449219-85.585938-85.585938c-21.910156-22.988281-54.519531-37.570312-90.945312-37.570312-65.976563 0-119.460938 47.832031-119.460938 106.832031v25.257812c0 28.261719 12.277344 53.957032 32.3125 73.0625l93.582032 93.582032c93.859374-4.195313 168.824218-80.984375 170.097656-175.578125zm0 0",
    fill: "url(#linear1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m198.496094 174.53125h-20.984375v-62.144531c0-13.175781-10.71875-23.898438-23.898438-23.898438h-71.941406v-20.984375h71.941406c24.75 0 44.882813 20.132813 44.882813 44.882813zm0 0",
    fill: "url(#linear2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m109.304688 83.59375c0 16.804688-13.625 30.425781-30.429688 30.425781s-30.429688-13.621093-30.429688-30.425781 13.625-30.429688 30.429688-30.429688 30.429688 13.625 30.429688 30.429688zm0 0",
    fill: "url(#linear3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m246.652344 30.429688h20.984375v144.101562h-20.984375zm0 0",
    fill: "url(#linear4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m287.570312 30.429688c0 16.804687-13.621093 30.425781-30.425781 30.425781-16.804687 0-30.429687-13.621094-30.429687-30.425781 0-16.808594 13.625-30.429688 30.429687-30.429688 16.804688 0 30.425781 13.621094 30.425781 30.429688zm0 0",
    fill: "url(#radial0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m337.289062 174.53125h-20.988281v-109.714844c0-24.746094 20.136719-44.882812 44.882813-44.882812h71.941406v20.988281h-71.941406c-13.175782 0-23.894532 10.71875-23.894532 23.894531zm0 0",
    fill: "url(#linear5)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m463.554688 30.429688c0 16.804687-13.625 30.425781-30.429688 30.425781s-30.429688-13.621094-30.429688-30.425781c0-16.808594 13.625-30.429688 30.429688-30.429688s30.429688 13.621094 30.429688 30.429688zm0 0",
    fill: "url(#linear6)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m313.503906 337.46875h20.984375v62.144531c0 13.175781 10.71875 23.898438 23.898438 23.898438h71.941406v20.984375h-71.941406c-24.75 0-44.882813-20.132813-44.882813-44.882813zm0 0",
    fill: "url(#linear7)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m463.554688 428.40625c0 16.804688-13.625 30.429688-30.429688 30.429688s-30.429688-13.625-30.429688-30.429688 13.625-30.425781 30.429688-30.425781 30.429688 13.621093 30.429688 30.425781zm0 0",
    fill: "url(#linear8)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m244.363281 337.46875h20.984375v144.101562h-20.984375zm0 0",
    fill: "url(#linear9)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m285.285156 481.570312c0 16.804688-13.625 30.429688-30.429687 30.429688-16.804688 0-30.425781-13.625-30.425781-30.429688 0-16.804687 13.621093-30.425781 30.425781-30.425781 16.804687 0 30.429687 13.621094 30.429687 30.425781zm0 0",
    fill: "url(#radial1)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m174.710938 337.46875h20.988281v109.714844c0 24.746094-20.136719 44.882812-44.882813 44.882812h-71.941406v-20.988281h71.941406c13.175782 0 23.894532-10.71875 23.894532-23.894531zm0 0",
    fill: "url(#linear10)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m109.304688 481.570312c0 16.804688-13.625 30.429688-30.429688 30.429688s-30.429688-13.625-30.429688-30.429688c0-16.804687 13.625-30.425781 30.429688-30.425781s30.429688 13.621094 30.429688 30.425781zm0 0",
    fill: "url(#linear11)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m337.46875 246.652344h144.101562v20.984375h-144.101562zm0 0",
    fill: "url(#linear12)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m512 257.144531c0 16.804688-13.625 30.425781-30.429688 30.425781-16.804687 0-30.425781-13.621093-30.425781-30.425781 0-16.804687 13.621094-30.429687 30.425781-30.429687 16.804688 0 30.429688 13.625 30.429688 30.429687zm0 0",
    fill: "url(#linear13)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m30.429688 244.363281h144.101562v20.984375h-144.101562zm0 0",
    fill: "url(#linear14)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m60.855469 254.855469c0 16.804687-13.621094 30.429687-30.425781 30.429687-16.808594 0-30.429688-13.625-30.429688-30.429687 0-16.804688 13.621094-30.425781 30.429688-30.425781 16.804687 0 30.425781 13.621093 30.425781 30.425781zm0 0",
    fill: "url(#linear15)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m377.113281 242.125c0-59-53.484375-106.832031-119.460937-106.832031-65.976563 0-119.460938 47.832031-119.460938 106.832031v25.257812c0 59.003907 53.484375 106.832032 119.460938 106.832032 65.976562 0 119.460937-47.828125 119.460937-106.832032 0-.082031 0-25.171874 0-25.257812zm0 0",
    fill: "url(#linear16)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m356.039062 181.527344c-21.546874-27.925782-57.574218-46.234375-98.386718-46.234375s-76.839844 18.308593-98.386719 46.234375v146.453125c21.546875 27.929687 57.574219 46.234375 98.386719 46.234375s76.839844-18.304688 98.386718-46.234375zm0 0",
    fill: "url(#linear17)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m187.582031 353.910156c19.6875 12.769532 43.890625 20.304688 70.070313 20.304688 26.179687 0 50.382812-7.535156 70.070312-20.304688v-198.3125c-19.683594-12.769531-43.890625-20.304687-70.070312-20.304687-26.179688 0-50.382813 7.535156-70.070313 20.304687zm0 0",
    fill: "url(#linear18)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m230.511719 371.445312c8.71875 1.8125 17.804687 2.769532 27.140625 2.769532 9.335937 0 18.421875-.957032 27.140625-2.769532v-233.382812c-8.71875-1.808594-17.804688-2.769531-27.140625-2.769531-9.335938 0-18.421875.960937-27.140625 2.769531zm0 0",
    fill: "url(#linear19)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m377.113281 242.125c0-59-53.484375-106.832031-119.460937-106.832031-65.976563 0-119.460938 47.832031-119.460938 106.832031 0 59.003906 53.484375 106.835938 119.460938 106.835938 65.976562 0 119.460937-47.832032 119.460937-106.835938zm0 0",
    fill: "url(#radial2)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m363.792969 242.125c0-52.421875-47.523438-94.917969-106.140625-94.917969-58.617188 0-106.136719 42.496094-106.136719 94.917969s47.519531 94.917969 106.136719 94.917969c58.617187 0 106.140625-42.496094 106.140625-94.917969zm0 0",
    fill: "url(#radial3)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m353.738281 242.125c0-47.457031-43.019531-85.929688-96.085937-85.929688s-96.085938 38.472657-96.085938 85.929688 43.019532 85.929688 96.085938 85.929688 96.085937-38.472657 96.085937-85.929688zm0 0",
    fill: "url(#radial4)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m371.25 275.257812-83.132812-83.128906c-1.179688-1.847656-3.464844-3.382812-6.863282-4.605468-3.667968-1.316407-7.574218-2.210938-11.710937-2.703126-.222657-.140624-.449219-.261718-.675781-.367187l-6.132813-6.570313c-.960937-.707031-1.996094-1.0625-3.109375-1.0625-1.214844 0-2.253906.355469-3.109375 1.0625-.863281.710938-1.292969 1.519532-1.292969 2.429688v4.402344c-8.195312.910156-15.050781 3.640625-20.5625 8.195312-5.515625 4.550782-8.273437 11.222656-8.273437 20.011719 0 3.132813.355469 5.984375 1.0625 8.558594s1.871093 4.820312 3.492187 6.738281c1.617188 1.921875 3.160156 3.5625 4.628906 4.925781.011719.007813.023438.019531.03125.027344 0 0 19.085938 19.085937 19.09375 19.09375.179688.191406.351563.367187.527344.550781v25.386719c-4.484375-.304687-8.429687-1.464844-11.847656-3.484375-3.414062-2.019531-6.09375-3.910156-8.050781-5.679688-1.953125-1.765624-3.53125-2.652343-4.730469-2.652343-1.8125 0-3.417969.960937-4.828125 2.878906-1.40625 1.917969-2.109375 3.839844-2.109375 5.757813 0 3.066406 1.726562 6.085937 5.183594 9.066406l60.953125 60.953125c38.488281-9.589844 69.136719-35.984375 81.457031-69.785157zm0 0",
    fill: "url(#linear20)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m223.65625 275.023438c0-1.917969.703125-3.835938 2.109375-5.753907 1.410156-1.921875 3.019531-2.882812 4.828125-2.882812 1.199219 0 2.777344.886719 4.730469 2.652343 1.957031 1.769532 4.636719 3.664063 8.050781 5.679688 3.417969 2.019531 7.363281 3.179688 11.847656 3.484375v-35.59375c-3.035156-1.109375-5.363281-1.992187-6.980468-2.648437-1.617188-.65625-3.769532-1.617188-6.449219-2.878907-2.683594-1.261719-4.757813-2.574219-6.222657-3.9375-1.46875-1.363281-3.011718-3.003906-4.628906-4.925781-1.621094-1.917969-2.785156-4.164062-3.492187-6.738281s-1.0625-5.425781-1.0625-8.558594c0-8.789063 2.757812-15.460937 8.273437-20.015625 5.511719-4.550781 12.367188-7.28125 20.5625-8.195312v-4.398438c0-.910156.429688-1.722656 1.292969-2.429688.855469-.707031 1.894531-1.0625 3.109375-1.0625 1.113281 0 2.148438.355469 3.109375 1.0625.960937.707032 1.445313 1.519532 1.445313 2.429688v4.097656c6.167968.203125 11.859374 1.238282 17.074218 3.109375 5.207032 1.875 7.8125 4.476563 7.8125 7.816407 0 1.820312-.613281 3.71875-1.835937 5.691406-1.222657 1.972656-2.859375 2.960937-4.898438 2.960937-.804687 0-3.023437-.859375-6.644531-2.582031-3.628906-1.71875-7.464844-2.730469-11.507812-3.035156v30.757812c4.023437 1.515625 7.367187 2.953125 10.035156 4.316406 2.664062 1.363282 5.484375 3.257813 8.453125 5.683594 2.96875 2.421875 5.207031 5.476563 6.714843 9.160156 1.507813 3.6875 2.265626 8.003907 2.265626 12.953126 0 9.039062-2.464844 16.222656-7.398438 21.554687-4.929688 5.332031-11.621094 8.605469-20.070312 9.824219v5.070312c0 .894532-.484376 1.6875-1.445313 2.386719-.960937.691406-1.996094 1.042969-3.109375 1.042969-1.214844 0-2.253906-.351563-3.113281-1.042969-.859375-.695313-1.289063-1.492187-1.289063-2.386719v-4.617187c-8.800781-.101563-16.265625-2.113281-22.386718-6.039063-6.121094-3.925781-9.179688-7.929687-9.179688-12.011718zm17.757812-63.613282c0 3.9375 1.226563 6.945313 3.679688 9.011719 2.453125 2.070313 6.132812 4.015625 11.039062 5.832031v-27.59375c-9.8125 1.214844-14.71875 5.464844-14.71875 12.75zm21.855469 66.492188c8.902344-1.617188 13.355469-6.617188 13.355469-14.996094 0-4.441406-1.164062-7.925781-3.492188-10.449219-2.328124-2.523437-5.613281-4.695312-9.863281-6.515625zm0 0",
    fill: "url(#linear21)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollar);
export default __webpack_public_path__ + "static/media/icon-dollar.32eb2924f862914c440c228fb398f415.svg";
export { ForwardRef as ReactComponent };